import { createReducer } from "@reduxjs/toolkit";
import type { RetrievalState } from "@redux/state/shared-types";
import type { AdminDocumentaryResourceVM } from "@shared-kernel/domain/types/documentary-resource";
import { documentaryResourceCatalogRetrieve } from "./documentary-resource-catalog-retrieve";

const initialState: RetrievalState<AdminDocumentaryResourceVM[]> = { fetching: "idle", data: [] };

export const documentaryResourceCatalogRetrieveReducer = createReducer<RetrievalState<AdminDocumentaryResourceVM[]>>(
  initialState,
  builder => {
    builder.addCase(documentaryResourceCatalogRetrieve.fulfilled, (state, { payload }) => {
      return {
        ...state,
        data: payload,
        fetching: "success",
      };
    });
    builder.addCase(documentaryResourceCatalogRetrieve.pending, state => {
      return {
        ...state,
        fetching: "pending",
      };
    });
    builder.addCase(documentaryResourceCatalogRetrieve.rejected, state => {
      return {
        ...state,
        fetching: "failed",
      };
    });
  },
);
